export default __webpack_public_path__ + "static/3-75fb2018ac3be50fa4ed16f09ddaa20f.png";